import data from '@iez/lib/data/'
import waitFor from '@iez/lib/wait-for/'
import user from '@iez/lib/user/'
import router from '@iez/core/router/'
import { noop } from 'lodash'
import firebase from '@firebase/app'
import '@firebase/auth'
import setReactNativeResponseCallback from '@iez/lib/set-react-native-response-callback/'

const getUserIdInHasura = async ({ uid }) => {
  const user = data.get({
    root: 'users',
    one: true,
    request: {
      where: {
        firebaseUserId: {
          _eq: uid
        }
      }
    },
    fields: ['id'],
    realtime: () => !user.value,
    isCalledFromComponent: false
  })
  await waitFor({
    dependencies: () => user.value
  })
  user.value.$clean()
  return user.value.id
}

export default () => {
  user.hasToBeReady = true
  const onAuthStateChanged = async ({ user, token }) => {
    const userFirebase = user
    if (userFirebase) {
      localStorage.setItem(`onboarding`, true)
      const id = await getUserIdInHasura({ uid: userFirebase.uid })
      data.setUser({ token, id })
      /* analytics.logEvent(user.isNewUser ? `sign_up` : `login`)
      analytics.setUserId(userFirebase.uid) */
      setTimeout(() => {
        router.replace({
          name: `Home`
        }).catch(noop)
      }, 0)
    } else {
      data.unsetUser()
    }
  }

  if (window.ReactNativeWebView) {
    setTimeout(() => {
      setReactNativeResponseCallback({
        name: `onAuthStateChanged`,
        callback: onAuthStateChanged
      })
    }, 1000)
  } else {
    firebase.auth().onAuthStateChanged(
      async user => {
        const token = user
          ? (await user.getIdTokenResult(true)).token
          : null
        onAuthStateChanged({ user, token })
      }
    )
  }
}
